module.exports = __webpack_public_path__ + "contentweb/app/pages/Solutions/static/images/Johnson_Johnson.60da6bb8.svg";